module.exports = __webpack_public_path__ + "media/images/woman-d4907fbf3d8046ee9ce04a973c2289b4.jpg";